import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createApiKey } from '../../../../common/api/clients/apiKey.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useApiKeyCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createApiKey,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.apiKeys.list._def });
        },
    });
};
